/* WA flow fixes (26/10/2026): back link, "Pairs with" from goes-with picks, Add from the pair card,
   and the category bar's "Filter & sort" button. Delegated listeners; safe to load more than once. */
(function () {
  if (window.waFlow) return;
  window.waFlow = true;

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '£' + v;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function init() {
    // Back link: when the shopper arrived from that collection page, return to the exact page (keeps filters, sort, page).
    var back = document.querySelector('[data-wa-back]');
    if (back && document.referrer) {
      try {
        var ref = new URL(document.referrer);
        if (ref.host === location.host && ref.pathname.indexOf(back.getAttribute('data-wa-back')) === 0 && ref.pathname.indexOf('/products/') === -1) {
          back.href = ref.pathname + ref.search;
        }
      } catch (e) {}
    }

    // Collections without filters (e.g. the Edition page): no Filter & sort button
    if (!document.querySelector('.facets__button-show')) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-wa-open-filters]'), function (b) { b.hidden = true; });
    }

    // Pairs with: no matching piece by name, so use Shopify's goes-with picks (first one in stock).
    var box = document.querySelector('[data-wa-pair-fetch]');
    if (box) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'recommendations/products.json?product_id=' + box.getAttribute('data-wa-pair') + '&limit=4&intent=complementary')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var p = (d.products || []).filter(function (x) { return x.available; })[0];
          if (!p) return;
          var opts = p.variants.filter(function (v) { return v.available; });
          var single = p.variants.length === 1;
          var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
          box.innerHTML =
            '<div class="wa-pair__card">' +
              '<a class="wa-pair__img" href="' + p.url + '">' + (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=240" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
              '<div class="wa-pair__body"><span class="wa-pair__eyebrow">Pairs with</span><a class="wa-pair__title" href="' + p.url + '">' + esc(p.title) + '</a><span class="wa-pair__price">' + money(p.price) + '</span></div>' +
              '<form class="wa-flow-add wa-pair__form" action="/cart/add" method="post">' +
                (single ? '<input type="hidden" name="id" value="' + p.variants[0].id + '">'
                        : '<label class="visually-hidden" for="WaPair-' + p.id + '">Size</label><select id="WaPair-' + p.id + '" name="id" required><option value="">Size</option>' +
                          opts.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') + '</select>') +
                '<input type="hidden" name="quantity" value="1"><button type="submit" class="wa-pair__add">Add</button><p class="wa-flow-err" role="alert"></p>' +
              '</form>' +
            '</div>';
        })
        .catch(function () {});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Add from the pair card through the theme's cart drawer (same calls as the product form).
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.wa-flow-add');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var err = form.querySelector('.wa-flow-err');
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var data = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      data.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      data.append('sections_url', window.location.pathname);
    }
    btn.disabled = true;
    err.textContent = '';
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { err.textContent = res.description || res.message || 'Could not add to bag'; return; }
        if (!cart || typeof cart.renderContents !== 'function') { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }
        cart.classList.remove('is-empty');
        cart.renderContents(res);
        if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'wa-flow' });
      })
      .catch(function () { err.textContent = 'Could not add to bag. Please try again.'; })
      .finally(function () { btn.disabled = false; });
  });

  // Category bar: "Filter & sort" scrolls to the theme's filter row and opens the filters.
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-wa-open-filters]')) return;
    var show = document.querySelector('.facets__button-show');
    var row = document.querySelector('.facets__horizontal-top') || show;
    if (row) {
      var bar = document.querySelector('[data-wa-cbar]');
      var off = (bar ? bar.getBoundingClientRect().height : 0) + 80;
      window.scrollTo({ top: row.getBoundingClientRect().top + window.pageYOffset - off, behavior: 'smooth' });
    }
    if (show && !show.classList.contains('active')) show.click();
  });

  // Keep the current category chip in view in the sideways-scrolling bar
  function centreChip() {
    var cur = document.querySelector('.wa-cbar__chip.is-current');
    var nav = cur && cur.parentElement;
    if (nav) nav.scrollLeft = Math.max(0, cur.getBoundingClientRect().left - nav.getBoundingClientRect().left + nav.scrollLeft - nav.clientWidth / 2 + cur.clientWidth / 2);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', centreChip); else centreChip();
  // Product gallery on phones: "‹ 1 / n ›" under the swipeable photos (scroll-snap list from the theme's grid option)
  function galleryCount() {
    var list = document.querySelector('.product__outer--static-multicolumns-aside .product__media-list');
    if (!list || list.dataset.waCount) return;
    var items = list.querySelectorAll(':scope > .product__media-item');
    if (items.length < 2) return;
    list.dataset.waCount = '1';
    var bar = document.createElement('div');
    bar.className = 'wa-gal-count';
    bar.innerHTML = '<button type="button" aria-label="Previous photo">‹</button><span aria-live="polite">1 / ' + items.length + '</span><button type="button" aria-label="Next photo">›</button>';
    list.parentNode.insertBefore(bar, list.nextSibling);
    var prev = bar.children[0], label = bar.children[1], next = bar.children[2];
    function current() { return Math.round(list.scrollLeft / list.clientWidth); }
    function update() {
      var i = current();
      label.textContent = (i + 1) + ' / ' + items.length;
      prev.disabled = i === 0;
      next.disabled = i === items.length - 1;
    }
    prev.addEventListener('click', function () { list.scrollTo({ left: (current() - 1) * list.clientWidth, behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollTo({ left: (current() + 1) * list.clientWidth, behavior: 'smooth' }); });
    list.addEventListener('scroll', update, { passive: true });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', galleryCount); else galleryCount();
})();
